module.exports = __webpack_public_path__ + "img/face-glasses.0843cf43.svg";